import { lazy } from 'react';
const SheetDryerOutput = lazy(() => import('./SheetDryerOutput'));

const SheetDryerOutputRoutes = [
  {
    path: '/sheetDryerOutput',
    component: SheetDryerOutput
  }
];

export default SheetDryerOutputRoutes;
